(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const decrease = event.target.closest('[data-cart-page-decrease]');
    const increase = event.target.closest('[data-cart-page-increase]');
    if (!decrease && !increase) return;
    const control = event.target.closest('[data-cart-page-quantity]');
    const input = control?.querySelector('input');
    if (!input) return;
    const current = Number(input.value || 0);
    input.value = increase ? current + 1 : Math.max(0, current - 1);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["xem-combo-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('xem-combo-products')) {
    customElements.define(
      'xem-combo-products',
      class XemComboProducts extends HTMLElement {
        connectedCallback() {
          this.rail = this.querySelector('[data-combo-rail]');
          this.previous = this.querySelector('[data-combo-prev]');
          this.next = this.querySelector('[data-combo-next]');

          if (!this.rail || !this.previous || !this.next) return;

          this.previous.addEventListener('click', () => this.scrollRail(-1));
          this.next.addEventListener('click', () => this.scrollRail(1));
        }

        scrollRail(direction) {
          const amount = this.rail.clientWidth * 0.85 * direction;
          this.rail.scrollBy({ left: amount, behavior: 'smooth' });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["xem-customer-results"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '.xem-customer-results__card';

    const revealCards = (root = document) => {
      const cards = root.querySelectorAll(selector);

      if (!cards.length) return;

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
        cards.forEach((card) => card.classList.add('is-visible'));
        return;
      }

      const observer = new IntersectionObserver(
        (entries, currentObserver) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;

            entry.target.classList.add('is-visible');
            currentObserver.unobserve(entry.target);
          });
        },
        { rootMargin: '0px 0px -10% 0px', threshold: 0.16 }
      );

      cards.forEach((card) => observer.observe(card));
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => revealCards());
    } else {
      revealCards();
    }

    document.addEventListener('shopify:section:load', (event) => revealCards(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["xem-faq"] && !Shopify.designMode) return;
  try {
    
  class XemFaqSection {
    constructor(section) {
      this.section = section;
      this.items = Array.from(section.querySelectorAll('[data-xem-faq-item]'));
      this.buttons = this.items.map((item) => item.querySelector('.xem-faq__question')).filter(Boolean);

      this.bindAccordion();
      this.bindReveal();
    }

    bindAccordion() {
      this.buttons.forEach((button) => {
        button.addEventListener('click', () => {
          const item = button.closest('[data-xem-faq-item]');
          const willOpen = button.getAttribute('aria-expanded') !== 'true';

          this.items.forEach((currentItem) => {
            const currentButton = currentItem.querySelector('.xem-faq__question');
            currentItem.classList.remove('is-open');
            if (currentButton) currentButton.setAttribute('aria-expanded', 'false');
          });

          if (willOpen) {
            item.classList.add('is-open');
            button.setAttribute('aria-expanded', 'true');
          }
        });
      });
    }

    bindReveal() {
      if (!('IntersectionObserver' in window)) {
        this.section.classList.add('is-visible');
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.section.classList.add('is-visible');
              observer.unobserve(this.section);
            }
          });
        },
        { threshold: 0.18 }
      );

      observer.observe(this.section);
    }
  }

  document.querySelectorAll('.xem-faq').forEach((section) => new XemFaqSection(section));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["xem-hero-slideshow"] && !Shopify.designMode) return;
  try {
    
  class XemHeroSlideshow extends HTMLElement {
    constructor() {
      super();
      this.index = 0;
      this.timer = null;
      this.touchStartX = 0;
      this.touchStartY = 0;
      this.suppressClick = false;
      this.pauseReasons = new Set();
    }

    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-xem-hero-slide]'));
      this.viewport = this.querySelector('[data-xem-hero-viewport]');
      this.mobileQuery = window.matchMedia('(max-width: 47.99rem)');
      this.tabletQuery = window.matchMedia('(max-width: 63.99rem)');

      if (this.slides.length < 1) return;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.autoplay = this.dataset.autoplay === 'true' && !this.reducedMotion;
      this.interval = this.getInterval();
      this.updateCtaOffset();
      this.updateSlideAccessibility();

      this.mobileQuery.addEventListener('change', () => {
        this.interval = this.getInterval();
        this.updateCtaOffset();
        this.restart();
      });

      this.tabletQuery.addEventListener('change', () => this.updateCtaOffset());

      this.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') this.previous();
        if (event.key === 'ArrowRight') this.next();
      });

      this.addEventListener('mouseenter', () => this.pause('hover'));
      this.addEventListener('mouseleave', () => this.resume('hover'));
      this.addEventListener('focusin', () => this.pause('focus'));
      this.addEventListener('focusout', () => this.resume('focus'));

      this.viewport?.addEventListener('touchstart', (event) => {
        const touch = event.changedTouches[0];
        this.touchStartX = touch?.clientX || 0;
        this.touchStartY = touch?.clientY || 0;
      }, { passive: true });

      this.viewport?.addEventListener('touchend', (event) => {
        if (this.slides.length < 2) return;

        const touch = event.changedTouches[0];
        const distanceX = (touch?.clientX || 0) - this.touchStartX;
        const distanceY = (touch?.clientY || 0) - this.touchStartY;

        if (Math.abs(distanceX) < 45 || Math.abs(distanceX) <= Math.abs(distanceY)) return;

        this.suppressClick = true;
        window.setTimeout(() => {
          this.suppressClick = false;
        }, 350);

        if (distanceX > 0) this.previous();
        if (distanceX < 0) this.next();
      }, { passive: true });

      this.viewport?.addEventListener('click', (event) => {
        if (!this.suppressClick) return;
        event.preventDefault();
        event.stopPropagation();
        this.suppressClick = false;
      }, true);

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          this.pause('hidden');
          return;
        }

        this.resume('hidden');
      });

      this.start();
    }

    disconnectedCallback() {
      this.stop();
    }

    previous() {
      const nextIndex = (this.index - 1 + this.slides.length) % this.slides.length;
      this.goTo(nextIndex);
    }

    next() {
      const nextIndex = (this.index + 1) % this.slides.length;
      this.goTo(nextIndex);
    }

    getInterval() {
      if (this.mobileQuery.matches) {
        return Number(this.dataset.mobileInterval || 7000);
      }

      return Number(this.dataset.desktopInterval || 6500);
    }

    getCtaOffset(slide) {
      if (!slide) return '29px';
      if (this.mobileQuery.matches) return `${slide.dataset.ctaBottomMobile || 27}px`;
      if (this.tabletQuery.matches) return `${slide.dataset.ctaBottomTablet || 29}px`;
      return `${slide.dataset.ctaBottomDesktop || 29}px`;
    }

    updateCtaOffset() {
      this.style.setProperty('--xem-hero-cta-bottom', this.getCtaOffset(this.slides[this.index]));
    }

    updateSlideAccessibility() {
      this.slides.forEach((slide, slideIndex) => {
        const link = slide.querySelector('[data-xem-hero-link]');
        const isActive = slideIndex === this.index;

        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');

        if (!link) return;
        if (isActive) {
          link.removeAttribute('tabindex');
          return;
        }

        link.setAttribute('tabindex', '-1');
      });
    }

    goTo(nextIndex) {
      if (nextIndex === this.index || !this.slides[nextIndex]) return;

      const currentSlide = this.slides[this.index];
      const nextSlide = this.slides[nextIndex];
      const shouldMoveFocus = currentSlide.contains(document.activeElement);

      currentSlide.classList.remove('is-active');
      nextSlide.classList.add('is-active');

      this.index = nextIndex;
      this.updateSlideAccessibility();
      this.updateCtaOffset();

      if (shouldMoveFocus) {
        nextSlide.querySelector('[data-xem-hero-link]')?.focus();
      }

      this.restart();
    }

    start() {
      if (!this.autoplay || this.pauseReasons.size > 0 || this.slides.length < 2) return;
      this.stop();
      this.timer = window.setInterval(() => this.next(), this.interval);
    }

    stop() {
      if (!this.timer) return;
      window.clearInterval(this.timer);
      this.timer = null;
    }

    pause(reason = 'manual') {
      this.pauseReasons.add(reason);
      this.stop();
    }

    resume(reason = 'manual') {
      this.pauseReasons.delete(reason);
      this.start();
    }

    restart() {
      this.stop();
      this.start();
    }
  }

  if (!customElements.get('xem-hero-slideshow')) {
    customElements.define('xem-hero-slideshow', XemHeroSlideshow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["xem-results-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '.xem-results-page__card';

    const revealCards = (root = document) => {
      const cards = root.querySelectorAll(selector);

      if (!cards.length) return;

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
        cards.forEach((card) => card.classList.add('is-visible'));
        return;
      }

      const observer = new IntersectionObserver(
        (entries, currentObserver) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;

            entry.target.classList.add('is-visible');
            currentObserver.unobserve(entry.target);
          });
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
      );

      cards.forEach((card) => observer.observe(card));
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => revealCards());
    } else {
      revealCards();
    }

    document.addEventListener('shopify:section:load', (event) => revealCards(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["xem-shoppable-videos"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('xem-shoppable-videos')) {
    customElements.define(
      'xem-shoppable-videos',
      class extends HTMLElement {
        connectedCallback() {
          if (this.dataset.initialized === 'true') return;

          this.dialog = this.querySelector('[data-reel-dialog]');
          this.feed = this.querySelector('[data-reel-feed]');
          this.slides = [...this.querySelectorAll('[data-reel-slide]')];
          this.triggers = [...this.querySelectorAll('[data-reel-trigger]')];
          if (!this.dialog || !this.slides.length) return;

          this.dataset.initialized = 'true';
          this.activeIndex = 0;
          this.returnFocus = null;
          this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.autoplay = this.dataset.autoplay === 'true' && !this.reduceMotion;
          this.closeButton = this.querySelector('[data-reel-close]');
          this.muteButton = this.querySelector('[data-reel-mute]');
          this.mobileQuery = window.matchMedia('(max-width: 749px)');

          this.triggers.forEach((trigger) => {
            trigger.addEventListener('click', () => {
              this.open(Number(trigger.dataset.reelIndex), trigger);
            });
          });

          this.closeButton?.addEventListener('click', () => this.dialog.close());
          this.querySelector('[data-reel-previous]')?.addEventListener('click', () => this.move(-1));
          this.querySelector('[data-reel-next]')?.addEventListener('click', () => this.move(1));
          this.muteButton?.addEventListener('click', () => this.toggleMute());

          this.querySelectorAll('[data-reel-play]').forEach((button) => {
            button.addEventListener('click', () => {
              const video = button.closest('[data-reel-slide]')?.querySelector('[data-reel-video]');
              if (!video) return;
              if (video.paused) {
                video.play().catch(() => {});
              } else {
                video.pause();
              }
            });
          });

          this.querySelectorAll('[data-reel-video]').forEach((video) => {
            video.addEventListener('play', () => this.updatePlayState(video));
            video.addEventListener('pause', () => this.updatePlayState(video));
          });
          this.querySelectorAll('[data-quick-add-form]').forEach((form) => {
            form.addEventListener('submit', () => this.pauseAll(false));
          });

          this.mobileObserver = new IntersectionObserver(
            (entries) => {
              if (!this.dialog.open || !this.mobileQuery.matches) return;
              const activeEntry = entries
                .filter((entry) => entry.isIntersecting)
                .sort((first, second) => second.intersectionRatio - first.intersectionRatio)[0];
              if (activeEntry?.intersectionRatio >= 0.6) {
                this.activateMobile(Number(activeEntry.target.dataset.reelIndex));
              }
            },
            { root: this.feed, threshold: [0.6, 0.85] },
          );
          this.slides.forEach((slide) => this.mobileObserver.observe(slide));

          this.dialog.addEventListener('click', (event) => {
            if (event.target === this.dialog) this.dialog.close();
          });
          this.dialog.addEventListener('close', () => this.afterClose());
          this.dialog.addEventListener('cancel', () => this.pauseAll(true));
          this.mobileQuery.addEventListener('change', () => {
            if (this.dialog.open) this.show(this.activeIndex);
          });
        }

        open(index, trigger) {
          if (typeof this.dialog.showModal !== 'function') return;
          this.returnFocus = trigger;
          this.show(index);
          this.dialog.showModal();
          document.documentElement.classList.add('is-scroll-locked');
          window.requestAnimationFrame(() => {
            if (this.mobileQuery.matches) {
              this.feed.scrollTo({ top: this.slides[this.activeIndex].offsetTop, behavior: 'instant' });
              this.activateMobile(this.activeIndex);
            }
            this.closeButton?.focus();
          });
        }

        show(index) {
          this.activeIndex = (index + this.slides.length) % this.slides.length;
          this.pauseAll(true);

          if (this.mobileQuery.matches) {
            this.slides.forEach((slide) => {
              slide.hidden = false;
            });
            if (this.dialog.open) {
              this.feed.scrollTo({
                top: this.slides[this.activeIndex].offsetTop,
                behavior: this.reduceMotion ? 'auto' : 'smooth',
              });
              this.activateMobile(this.activeIndex);
            }
            return;
          }

          this.slides.forEach((slide, slideIndex) => {
            slide.hidden = slideIndex !== this.activeIndex;
          });

          const video = this.slides[this.activeIndex]?.querySelector('[data-reel-video]');
          if (this.muteButton) this.muteButton.hidden = !video;
          if (video) {
            video.muted = true;
            this.updateMuteState(video);
            if (this.autoplay) video.play().catch(() => {});
          }
        }

        move(amount) {
          this.show(this.activeIndex + amount);
        }

        activateMobile(index) {
          if (index === this.activeIndex && !this.slides[index]?.querySelector('[data-reel-video]')?.paused) return;
          this.activeIndex = index;
          this.pauseAll(false);
          const video = this.slides[this.activeIndex]?.querySelector('[data-reel-video]');
          if (this.muteButton) this.muteButton.hidden = !video;
          if (!video) return;
          video.muted = true;
          this.updateMuteState(video);
          if (this.autoplay) video.play().catch(() => {});
        }

        toggleMute() {
          const video = this.slides[this.activeIndex]?.querySelector('[data-reel-video]');
          if (!video) return;
          video.muted = !video.muted;
          this.updateMuteState(video);
        }

        updateMuteState(video) {
          const hasSound = !video.muted;
          this.muteButton?.setAttribute('aria-pressed', String(hasSound));
          this.muteButton?.setAttribute('aria-label', hasSound ? 'Mute video' : 'Unmute video');
        }

        updatePlayState(video) {
          const wrap = video.closest('.xem-shoppable-videos__video-wrap');
          const button = wrap?.querySelector('[data-reel-play]');
          wrap?.classList.toggle('is-playing', !video.paused);
          button?.setAttribute('aria-label', video.paused ? 'Play video' : 'Pause video');
        }

        pauseAll(reset) {
          this.querySelectorAll('[data-reel-video]').forEach((video) => {
            video.pause();
            if (reset) video.currentTime = 0;
          });
        }

        afterClose() {
          this.pauseAll(true);
          this.feed?.scrollTo({ top: 0, behavior: 'auto' });
          if (!document.querySelector('dialog[open]')) {
            document.documentElement.classList.remove('is-scroll-locked');
          }
          this.returnFocus?.focus();
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();
})();
